import React from 'react';
import calculator from '../partials/CalculatorHOC';
import {
  Row,
  Col,
  ButtonGroup,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from 'react-bootstrap';
import { IconBox, ToggleSwitch } from 'components';
import _ from 'lodash';

class DataPlanCalculator extends React.Component {
  constructor(props) {
    super(props);

    this.handleToggleEnablePlan = this.handleToggleEnablePlan.bind(this);
    this.handleIntervalChange = this.handleIntervalChange.bind(this);
    this.intervalSelector = this.intervalSelector.bind(this);
  }

  handleToggleEnablePlan(item) {
    if(!item.plan.interval) {
      $('.plan-selector-interval-buttons').animateBounce();
    }
    else {
      if(item.quantity == 1) {
        this.props.handleQuantityChange(item.plan, '0');
      }
      else {
        this.props.handleQuantityChange(item.plan, '1');
      }
    }
  }
  handleIntervalChange(interval, plan) {
    this.props.handleIntervalChange(interval, plan);
  }
  intervalSelector(plan, current_item, prices) {
    return (
      <div className='plan-selector-interval-buttons'>
        <Row>
          <Col md={8} xs={8} mdOffset={2} xsOffset={2}>
            <ButtonGroup justified>
              <Button
                onClick={() => this.handleIntervalChange('month', plan)}
                active={current_item.plan.interval == 'month'}
                >
                Monthly
              </Button>
              <Button
                onClick={() => this.handleIntervalChange('year', plan)}
                active={current_item.plan.interval == 'year'}
                >
                Yearly
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        <Row>
          <Col md={4} xs={4} mdOffset={2} xsOffset={2}>
            <p>{`$${(+(prices.month_plan_price) / 100).toFixed(2)} / month`}</p>
          </Col>
          <Col md={4} xs={4}>
            <p>{`$${(+(prices.year_plan_price) / 100).toFixed(2)} / year`}</p>
          </Col>
        </Row>
        <Row>
          <Col md={5} xs={5} style={{ marginTop: '5px', paddingRight: '5px' }}>
            <div className='pull-right'>
              <p>Enable Plan</p>
            </div>
          </Col>
          <Col md={2} xs={2}>
            <div className='data-plan-toggle-switch-container'>
              <ToggleSwitch
                on_condition={current_item.quantity == 1}
                type='primary'
                onClick={() => this.handleToggleEnablePlan(current_item)}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const { plans } = this.props;
    return (
      <div className='animated fadeIn'>
        <Row>
          {_.uniqBy(plans, 'name').map((plan, idx, plans_list) => {
            const { amount: month_plan_price } = plans.find(p => p.name == plan.name && p.interval == 'month');
            const { amount: year_plan_price } = plans.find(p => p.name == plan.name && p.interval == 'year');
            const current_item = this.props.data_items.find(item => item.plan.name == plan.name) || { plan: {} };
            return (
              <Col
                md={plans_list.length == 1 ? 6 : 4}
                mdOffset={plans_list.length == 1 ? 3 : 0}
                xs={12}
                key={plan._id}
                >
                <IconBox
                  show_icon={true}
                  type='primary'
                  icon_class='fa fa-database'
                  title={plan.name}
                  body={plan.description}
                  type='success'
                  CustomComponent={this.intervalSelector(plan, current_item, { month_plan_price, year_plan_price })}
                />
              </Col>
            )
          })}
        </Row>
      </div>
    )
  }
}

module.exports = calculator(DataPlanCalculator);



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/plans_calculator/partials/DataPlanCalculator.js